import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    z-index: 1000;
  `,
  content: css`
    width: 530px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
